import React, { ComponentProps, Fragment, ReactNode } from 'react';
import ReactSelectBase, { components } from 'react-select';
import ReactSelectAsyncCreatable from 'react-select/async-creatable';
import {
  SortableContainer,
  SortableElement, // @ts-expect-error ts-migrate(2724) FIXME: '"react-sortable-hoc"' has no exported member name... Remove this comment to see the full error message
  sortableHandle,
} from 'react-sortable-hoc';
import styled, { css } from 'styled-components';

import Box from 'components/Box';
import { ChevronDownIcon, ChevronUpIcon } from 'components/ChevronIcon';
import Icon from 'components/Icon';
import SelectInput from 'components/SelectInput';
import ClientOnly from 'containers/ClientOnly';
import { compose, getter } from 'utils/functional';

import { colors, transition } from '../theme';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const DropdownIndicator = (props: { menuIsOpen: boolean }) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <components.DropdownIndicator {...props}>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/destructuring-assignment */}
    {props.menuIsOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
  </components.DropdownIndicator>
);

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ClearIndicator = (props) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <components.ClearIndicator {...props}>
    <Icon name="close" fill="currentColor" width={12} height={12} />
  </components.ClearIndicator>
);

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ReactSelect = ({
  label,
  ...props
}: ComponentProps<typeof ReactSelectBase>) => (
  // TODO fix jsx-a11y/label-has-associated-control
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  <label>
    {label && <Box display="none">{label}</Box>}
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <ReactSelectBase {...props} />
  </label>
);

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const MultiValueRemove = ({
  innerProps,
  ...otherProps
}: {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  innerProps: Record<string, any>;
}) => (
  <components.MultiValueRemove
    innerProps={{
      'data-qa-id': 'react-select-remove',
      ...innerProps,
    }}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...otherProps}
  />
);

export const StyledSelectInput = styled(SelectInput)`
  height: 50px;
  padding: 0 calc(1em - 2px);
  border-radius: 7px;
  border: 1px solid ${colors.aluminum};
  color: ${colors.waterBlue};
`;
const styles = css`
  display: block;
  width: 100%;
  min-height: 45px;
  vertical-align: middle;
  color: #484848;
  font-size: 18px;

  &.react-select--is-disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transition: opacity ${transition} 0.5s;
  }

  .react-select__control {
    background-color: white;
    width: 100%;
    min-height: 45px;
    margin: 0;
    cursor: pointer;
  }

  .react-select__control--menu-is-open {
    .react-select__dropdown-indicator {
      svg {
        transform: rotate(180deg);
      }
    }
  }

  .react-select__input {
    height: 100%;
    padding-left: 0;
  }

  .react-select__value-container {
    display: flex;
    padding: 0 1em;
    align-items: center;
  }
  .react-select__value-container--has-value.react-select__value-container--is-multi {
    margin-left: -6px;
    padding: 2px 1em;
  }

  .react-select__indicators {
    padding-top: 2px;
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__dropdown-indicator {
    padding-right: 1em;
  }

  .react-select__single-value {
    margin: 0;
    max-width: calc(100% - 15px);
  }

  .react-select__single-value .select-description {
    display: none;
  }

  .react-select__multi-value {
    background: ${colors.platinum};
    color: ${colors.oceanBlue};
  }
  .react-select__multi-value__label {
    color: inherit;
  }
  .react-select__multi-value__remove {
    border-radius: 0 2px 2px 0;
    transition: all ${transition};
    &:hover {
      background: ${colors.waterBlue};
      color: white;
    }
  }

  .react-select__menu {
    z-index: 5;
    margin-top: 1px;
    border-radius: 0 0 4px 4px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.15);
    border: solid 1px #c4c8cc;
  }

  .react-select__menu-notice {
    text-align: left;
  }

  .react-select__option {
    display: flex;
    align-items: center;
    border-bottom: solid 1px #c4c8cc;
    color: #484848;
    padding: 0 1em;
    min-height: 45px;
    cursor: pointer;
    &:last-child {
      border-bottom: none;
    }
  }
  .react-select__option--is-selected {
    background-color: rgba(241, 241, 241, 1);
    color: inherit;
  }
  .react-select__option--is-focused {
    background-color: rgba(241, 241, 241, 1);
    color: inherit;
  }
`;

const formatOptionLabel = ({ label, description }) => (
  <Box display="flex" flexWrap="wrap" margin="10px 0">
    <Box flex="0 0 auto" width={[1, null, null, 1]}>
      {label}
    </Box>
    {description && (
      <Box
        className="select-description"
        marginTop="2px"
        flex="0 0 auto"
        width={[1, null, null, 1]}
        color={`${colors.battleshipGrey}`}
        fontSize="14px"
      >
        {description}
      </Box>
    )}
  </Box>
);

export const StyledSelect = styled(ReactSelect).attrs(
  ({ components: otherComponents }) => ({
    classNamePrefix: 'react-select',
    components: {
      DropdownIndicator,
      ClearIndicator,
      MultiValueRemove,
      ...otherComponents,
    },
    maxMenuHeight: 250,
  })
)`
  ${styles}
`;
const SortableMultiValue = SortableElement((props) => {
  // this prevents the menu from being opened/closed when the user clicks
  // on a value to begin dragging it. ideally, detecting a click (instead of
  // a drag) would still focus the control and toggle the menu, but that
  // requires some magic with refs that are out of scope for this example
  const onMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const innerProps = { ...props.innerProps, onMouseDown };
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <components.MultiValue {...props} innerProps={innerProps} />;
});
const SortableMultiValueLabel = sortableHandle((props) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <components.MultiValueLabel {...props} />
));
const SortableSelect = SortableContainer(ReactSelect);
export const StyledSelectSortable = styled(SortableSelect).attrs(
  ({ components: otherComponents }) => ({
    classNamePrefix: 'react-select',
    useDragHandle: true,
    // react-sortable-hoc props:
    axis: 'xy',
    distance: 0,
    // NOTE: must be 0 for selenium tests to work
    // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
    getHelperDimensions: ({ node }) => node.getBoundingClientRect(),
    components: {
      DropdownIndicator,
      ClearIndicator,
      MultiValueRemove,
      MultiValue: SortableMultiValue,
      MultiValueLabel: SortableMultiValueLabel,
      ...otherComponents,
    },
  })
)`
  ${styles}
`;
export const AsyncCreatable = styled(ReactSelectAsyncCreatable).attrs(() => ({
  classNamePrefix: 'react-select',
  components: {
    DropdownIndicator,
    ClearIndicator,
    MultiValueRemove,
  },
}))`
  ${styles}
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const Select = ({
  id,
  name,
  label,
  value,
  options,
  disabled,
  onChange,
  className,
  isClearable,
  isSearchable,
  ...props
}: {
  id?: string;
  'aria-label'?: string;
  customCompare?: (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arg0: Record<string, any>,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arg1: Record<string, any>
  ) => boolean;
  disableGreyOnNull?: boolean;
  name?: string;
  label?: ReactNode;
  value?: string | null | undefined;
  options: Array<{
    value: string;
    label: string;
    description?: string;
    disabled?: boolean;
  }>;
  disabled?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (...args: Array<any>) => any;
  className?: string;
  isClearable?: boolean;
  isSearchable?: boolean;
  noMargin?: boolean;
  placeholder?: string;
  'data-qa-id'?: string;
}) => {
  const classNames = props['data-qa-id']
    ? [`qa-id-${props['data-qa-id']}`]
    : [];

  if (className) {
    classNames.push(className);
  }

  const Container = label ? 'label' : Fragment;
  return (
    <ClientOnly
      placeholder={
        <StyledSelectInput
          options={options}
          value={typeof value === 'string' ? value : ''}
          onChange={onChange}
          className={classNames.join(' ')}
        />
      }
    >
      <Container>
        {label && <Box display="none">{label}</Box>}
        <StyledSelect
          name={name}
          options={options}
          value={options.filter(({ value: v }) => v === value)}
          isDisabled={disabled}
          onChange={onChange}
          formatOptionLabel={formatOptionLabel}
          isSearchable={isSearchable}
          isClearable={isClearable || false}
          className={classNames.join(' ')}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </Container>
    </ClientOnly>
  );
};

export default Select;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const SearchableSelect = ({
  filterOption,
  onChange,
  ...props
}: {
  className?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterOption?: (arg0: Record<string, any>, arg1: string) => boolean;
  id?: string;
  name?: string;
  label?: string;
  value: string | null | undefined;
  options: Array<{
    value: string;
    label: string;
  }>;
  disabled?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (...args: Array<any>) => any;
  'data-qa-id'?: string;
  isClearable?: boolean;
  placeholder?: string;
}) => (
  <Select
    onChange={compose(onChange, getter('value'))}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    isSearchable
  />
);
